import styled, { css } from 'styled-components';

const localVariables = {
    searchResultsPanelWidth: '304px',
};

type SearchResultsPanelStyledProps = {
    isOpen?: boolean;
};

type SearchResultsContentStyledProps = {
    isPanelActive: boolean;
};

export const ProductsSearchStyled = styled.div`
    ${({ theme }) =>
        css`
            position: relative;
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;

            @media ${theme.mediaQueries.queryVl} {
                flex-direction: row;
                flex-wrap: wrap;
                margin-bottom: 40px;
            }
        `}
`;

export const ProductsSearchPanelStyled = styled.div<SearchResultsPanelStyledProps>`
    ${({ theme, isOpen }) => css`
        display: none;
        position: absolute;
        width: 100%;

        ${isOpen &&
        css`
            display: block;
            z-index: ${theme.zIndex.menu};
        `};

        @media ${theme.mediaQueries.queryVl} {
            position: static;
            display: block;
            width: ${localVariables.searchResultsPanelWidth};
        }
    `}
`;

export const ProductsSearchContentStyled = styled.div<SearchResultsContentStyledProps>`
    ${({ theme, isPanelActive }) => css`
        display: flex;
        flex: 1;
        flex-direction: column;

        ${isPanelActive &&
        css`
            @media ${theme.mediaQueries.queryVl} {
                padding-left: 50px;
            }
        `}
    `}
`;
